import request from '../../../util/request';

// TODO: Update the api with new api once made
export const getActiveTrips = () => request.get('/crm/manualOrders');

export const postAcceptTripApi = data =>
  request.post(`/adc/order/accept/${data.orderId}`, data);
